import SwitchCerberusFake from "./switch";
import styles from "./styles";

const CerberusFake = ({ withouContainer }) => {
  return (
    <>
    <div className={withouContainer ? "" : "container"}>
      <div className="cerberus__fake">
        <div className="cerberus__fake--box">
          <div className="skeleton cerberus__fake--box--title" />
          <SwitchCerberusFake />
        </div>
        <div className="cerberus__fake--box">
          <div className="skeleton cerberus__fake--box--title" />
          <SwitchCerberusFake />
          <SwitchCerberusFake />
        </div>
      </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default CerberusFake;
